import { DestroyRef, Directive, ElementRef, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { isFunction } from '@skylab-shared/utils';
import { MenuItem } from './menu.model';
import { MenuService } from './menu.service';

const SUBMENU_OPEN_DELAY_MS = 150;

@Directive({ selector: '[skl-menu-side]' })
export class MenuSideDirective implements OnChanges {
    @Input('skl-menu-side') public collection!: MenuItem[];
    @Input('skl-menu-side-active') public isActive!: boolean;
    @Input('skl-menu-side-context') public context: unknown;
    @Output('skl-menu-side-close-parent') public closeParent = new EventEmitter<Event>();

    private closeFn?: () => void;
    private openTimer?: ReturnType<typeof setTimeout>;

    private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
    private readonly menuService = inject(MenuService);

    public constructor() {
        inject(DestroyRef).onDestroy(() => {
            this.clearOpenTimer();
            if (isFunction(this.closeFn)) {
                this.closeFn();
                this.closeFn = undefined;
            }
        });
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['isActive']) {
            this.clearOpenTimer();
            if (changes['isActive'].currentValue) {
                this.openTimer = setTimeout(() => this.onOpenSub(), SUBMENU_OPEN_DELAY_MS);
            } else if (isFunction(this.closeFn)) {
                this.closeFn();
                this.closeFn = undefined;
            }
        }
    }

    private clearOpenTimer(): void {
        if (this.openTimer != null) {
            clearTimeout(this.openTimer);
            this.openTimer = undefined;
        }
    }

    private onOpenSub(): void {
        if (!this.collection.length) return;
        const element = this.elementRef.nativeElement;
        const menuId = element.closest('[menu-id]')?.getAttribute('menu-id') ?? '';
        this.closeFn = this.menuService.showMenuSub(
            element,
            this.collection,
            this.context,
            () => this.closeParent.emit(),
            menuId
        );
    }
}
